import React from 'react'
import { Outlet } from 'react-router'
import { Container } from 'react-bootstrap'
import AppNavbar from '@/components/AppNavbar'
import useEmbedded from '@/hooks/useEmbedded'

export default function AppLayout() {
  const isEmbedded = useEmbedded()

  return (
    <>
      {!isEmbedded && <AppNavbar />}
      {isEmbedded ? <Outlet /> : <Container><Outlet /></Container>}
    </>
  )
}
